import { getNodesValueSum } from './get-nodes-value-sum.js';
import type { ColorToken } from '../../core/types/color-palette.js';
import type { Formatter } from '../../core/types/formatter.js';
import {
  AGGREGATED_NODE_COLOR,
  CLUSTER_OTHER_ID,
  DEFAULT_AGGREGATED_LABEL,
} from '../constants.js';
import { ClusterNode, LeafNode } from '../types/guards/node-guards.js';
import { InternalTreeMapNode } from '../types/internal.js';
import { type NameAccessor } from '../types/treemap.js';

const aggregatedColorToken = {
  Default: AGGREGATED_NODE_COLOR,
};

export const getAggregatedLeaf = (
  nodes: InternalTreeMapNode[],
  clusterName: string,
  formatter: Formatter,
  clusterColorToken?: ColorToken,
  nameAccessor?: NameAccessor,
): LeafNode => {
  const aggeregatedValue = getNodesValueSum(nodes);
  return {
    id: `other-${clusterName}`,
    value: aggeregatedValue,
    formattedValue: formatter(aggeregatedValue),
    name: DEFAULT_AGGREGATED_LABEL,
    color: nameAccessor ? aggregatedColorToken : clusterColorToken,
    ...(nameAccessor && {
      aggregatedNodes: nodes.map((node) => node[nameAccessor]),
    }),
  } as LeafNode;
};

export const getAggregatedCluster = (
  nodes: ClusterNode[],
  formatter: Formatter,
): ClusterNode => ({
  id: CLUSTER_OTHER_ID,
  value: getNodesValueSum(nodes),
  name: DEFAULT_AGGREGATED_LABEL,
  color: aggregatedColorToken,
  // for highlighting logic, the generated id must be 'other-cluster', same as CLUSTER_OTHER_ID
  children: [
    getAggregatedLeaf(nodes, 'cluster', formatter, aggregatedColorToken),
  ],
  aggregatedNodes: nodes.map((node) => node.name),
});
